/**
 * GOVX Featured Products Swiper Component
 * Initializes Swiper carousel for featured products section
 */

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

// Initialize Swiper when DOM is ready
function initGovxFeaturedProducts() {
  // Find all GOVX featured products swipers
  const swipers = document.querySelectorAll('.govx-featured-products-swiper-wrapper .swiper');

  swipers.forEach((swiperEl) => {
    // Extract section ID from class name like "govx-featured-products-swiper-123456"
    const classes = Array.from(swiperEl.classList);
    const swiperClass = classes.find(cls => cls.startsWith('govx-featured-products-swiper-'));
    if (!swiperClass) return;
    
    const sectionId = swiperClass.replace('govx-featured-products-swiper-', '');
    
    const swiper = new Swiper(swiperEl, {
      modules: [Navigation, Pagination],
      slidesPerView: 1.7,
      spaceBetween: 12,
      breakpoints: {
        640: {
          slidesPerView: 1.5,
          spaceBetween: 12,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
      },
      navigation: {
        nextEl: `.govx-featured-products-next-${sectionId}`,
        prevEl: `.govx-featured-products-prev-${sectionId}`,
      },
      pagination: {
        el: `.govx-featured-products-progress-${sectionId}`,
        type: 'progressbar',
      },
      loop: false,
      grabCursor: true,
    });
    return swiper;
  });
}

export default initGovxFeaturedProducts;

